import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebook } from 'react-icons/fa';
import logo from '../assets/logo.png';

function Navbar() {
    return (
        <nav className="navbar">
            <div className="logo">
                <img src={logo} alt="Prestige Clean Logo" className="logo-image" />
            </div>
            <ul className="nav-links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/contact">Contact</Link></li>
            </ul>
            <div className="social-links">
                <a href="https://www.instagram.com/prestigecleanhomeservices/" target="_blank" rel="noopener noreferrer">
                    <FaInstagram className="social-icon" />
                </a>
                <a href="https://www.facebook.com/people/Prestige-Clean/100092660852751/" target="_blank" rel="noopener noreferrer">
                    <FaFacebook className="social-icon" />
                </a>
            </div>
        </nav>
    );
}

export default Navbar;
